/**
 * Achievement Text Mapping
 * Maps BE AchievementType enum values to display text (title, tooltip, description)
 * Uses name and description from BE achievement definitions
 */

import { AchievementType } from 'pure-js/types/Achievement'

export interface AchievementTextMapping {
  title: string
  tooltip?: string
  description: string
}

/**
 * Text mapping for all BE achievement types
 * BE enum -> FE Title, Tooltip, Description
 * Name and description match BE achievement definitions exactly
 */
export const ACHIEVEMENT_TEXT_MAPPING: Record<AchievementType, AchievementTextMapping> = {
  [AchievementType.ROBOT_MASTER]: {
    title: 'Robot Master',
    tooltip: 'Unlock robots to help your team',
    description: 'Unlock robots to help your team'
  },
  [AchievementType.DRONE_COORDINATOR]: {
    title: 'Drone Coordinator',
    tooltip: 'Successfully call drones',
    description: 'Successfully call drones'
  },
  [AchievementType.RESOURCE_SHARER]: {
    title: 'Resource Sharer',
    tooltip: 'Share resources with your teammates',
    description: 'Share resources with your teammates'
  },
  [AchievementType.ABILITY_SHARER]: {
    title: 'Ability Sharer',
    tooltip: 'Share abilities with your teammates',
    description: 'Share abilities with your teammates'
  },
  [AchievementType.RESCUER]: {
    title: 'Rescuer',
    tooltip: 'Rescue teammates in need',
    description: 'Rescue teammates in need'
  },
  [AchievementType.TEAM_PLAYER]: {
    title: 'Team Player',
    tooltip: 'Share resources and abilities with teammates',
    description: 'Share resources and abilities with teammates'
  },
  [AchievementType.URIDIUM_COLLECTOR]: {
    title: 'Uridium Collector',
    tooltip: 'Collect uridium during missions',
    description: 'Collect uridium during missions'
  },
  [AchievementType.EFFICIENCY_EXPERT]: {
    title: 'Efficiency Expert',
    tooltip: 'Return with fewer full oxygen tanks',
    description: 'Return with fewer full oxygen tanks'
  },
  [AchievementType.SURVIVOR]: {
    title: 'Survivor',
    tooltip: 'Minimize time spent paralyzed',
    description: 'Minimize time spent paralyzed'
  },
  [AchievementType.ACTIVE_EXPLORER]: {
    title: 'Active Explorer',
    tooltip: 'Stay active during missions',
    description: 'Stay active during missions'
  },
  [AchievementType.PUZZLE_SOLVER]: {
    title: 'Puzzle Solver',
    tooltip: 'Spend time solving drone puzzles',
    description: 'Spend time solving drone puzzles'
  },
  [AchievementType.ABILITY_USER]: {
    title: 'Ability User',
    tooltip: 'Use your abilities frequently',
    description: 'Use your abilities frequently'
  }
}

/**
 * Get text mapping for an achievement type
 * @param achievementType - BE AchievementType enum value
 * @returns Text mapping or default if not found
 */
export function getAchievementText(achievementType: AchievementType): AchievementTextMapping {
  return (
    ACHIEVEMENT_TEXT_MAPPING[achievementType] || {
      title: achievementType,
      description: `Achievement: ${achievementType}`
    }
  )
}
